import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const SET_BAKGROUND = 'SET_BAKGROUND'
export const SET_COLOR_SIDEBAR = 'SET_COLOR_SIDEBAR'
export const PROGRESS = 'PROGRESS'
export const SET_COLOR = 'SET_COLOR'

let store = new Vuex.Store({
  state: {
    background: null,
    color: null,
    sidebarColor: null,
    progress: true,
  },
  mutations: {
    [SET_BAKGROUND]: (state, data) => {
      state.background = data
    },
    [SET_COLOR]: (state, color) => {
      state.color = color
    },
    [SET_COLOR_SIDEBAR]: (state, color) => {
      state.sidebarColor = color
    },
    [PROGRESS]: (state, status) => {
      state.progress = status
    }
  }
})

export default store
